import { g as d } from "../../utils-BOfnFgIH.js";
import { I as l } from "../../constants-DeVuDy8J.js";
import { openBlock as n, createElementBlock as o, normalizeClass as s, createElementVNode as a } from "vue";
import { _ as u } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconFood",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(l).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return l[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded"), this.uniqueID = d();
  }
}, m = ["aria-label", "data-qa", "aria-hidden"], f = ["clip-path"], p = ["id"];
function h(e, t, r, _, g, i) {
  return n(), o("svg", {
    "aria-label": r.ariaLabel,
    class: s([i.iconSizeClass, "d-icon d-icon--food"]),
    "data-qa": i.dataQA,
    "aria-hidden": i.ariaHidden,
    role: "img",
    "data-name": "Food",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, [
    a("g", {
      "clip-path": `url(#${e.uniqueID}a)`
    }, [...t[0] || (t[0] = [
      a("path", {
        fill: "currentColor",
        "fill-rule": "evenodd",
        d: "M7.87.517a.5.5 0 0 1 .61.34l3 10a.5.5 0 0 1-.623.622l-10-3a.5.5 0 0 1-.34-.608 10.429 10.429 0 0 1 2.69-4.664A10.438 10.438 0 0 1 7.871.516ZM3.915 3.914a9.438 9.438 0 0 0-2.293 3.75l1.01.304c.407-1.345 1-2.484 1.874-3.39.88-.911 2.015-1.558 3.46-1.957l-.3-1a9.444 9.444 0 0 0-3.751 2.293Zm4.338-.335c-1.313.359-2.289.928-3.027 1.693-.735.762-1.262 1.747-1.635 2.983l6.665 2-2.003-6.676ZM7 5.5a.5.5 0 0 1 .5-.5h.005a.5.5 0 1 1 0 1H7.5a.5.5 0 0 1-.5-.5Zm-2 2a.5.5 0 0 1 .5-.5h.005a.5.5 0 1 1 0 1H5.5a.5.5 0 0 1-.5-.5Zm2.5.5a.5.5 0 0 1 .5-.5h.005a.5.5 0 1 1 0 1H8a.5.5 0 0 1-.5-.5Z",
        "clip-rule": "evenodd"
      }, null, -1)
    ])], 8, f),
    a("defs", null, [
      a("clipPath", {
        id: `${e.uniqueID}a`
      }, [...t[1] || (t[1] = [
        a("path", {
          fill: "#fff",
          d: "M0 0h12v12H0z"
        }, null, -1)
      ])], 8, p)
    ])
  ], 10, m);
}
const S = /* @__PURE__ */ u(c, [["render", h]]);
export {
  S as default
};
//# sourceMappingURL=food.js.map
